import { Link } from '@/app/[lang]/(main)/components/shared/PrivateLink/ServerLink';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { formatBadgeCount } from '@/utils/formatBadgeCount';

type HeaderLinkProps = {
  iconLink: string;
  count: number;
  link?: string;
  className?: string;
  textClassName?: string;
  text?: string;
  imageAlt?: string;
  title?: string;
};

export const HeaderLink = ({
  iconLink,
  title,
  count,
  link,
  text = '',
  className,
  imageAlt = '',
  textClassName = '',
}: HeaderLinkProps) => {
  const content = (
    <>
      <div className={twMerge('size-[28px] flex items-center justify-center relative', className)}>
        <span className='relative size-[24px]'>
          <Image width={24} height={24} alt={imageAlt} src={iconLink} className='size-[24px]' />
          {count > 0 && (
            <span className='absolute -top-[6px] start-[11px] flex h-[16px] min-w-[20px] items-center justify-center rounded-full bg-red-day px-[5px] text-[10px] font-bold leading-none tabular-nums text-white whitespace-nowrap [text-box:trim-both_cap_alphabetic]'>
              {formatBadgeCount(count)}
            </span>
          )}
        </span>
      </div>
      {text && <div className={twMerge('text-m text-text-primary-day', textClassName)}>{text}</div>}
    </>
  );
  return (
    <>
      {link ? (
        <Link title={title} href={link} className='flex gap-[8px] items-center'>
          {content}
        </Link>
      ) : (
        <span className='flex gap-[8px] items-center'>{content}</span>
      )}
    </>
  );
};
